import React from 'react';
import { RoleService } from 'Services';
import ReportsTable from '../ReportsTable';
import NewReportButton from '../NewReportBtn';
import styles from './ReportsContainer.css';

type Props = {
    header: string;
    reportType: ReportType;
};

const ReportsContainer = ({ header, reportType }: Props) => {
    return (
        <>
            <span className={styles.tableHeader}>{header}</span>
            {RoleService.isReportsAdmin() && (
                <div className={styles.newReportBtn}>
                    <NewReportButton reportType={reportType} />
                </div>
            )}
            <ReportsTable reportType={reportType} />
        </>
    );
};

export default React.memo(ReportsContainer);
